import {
  ConsolePostEditQuery,
  Maybe,
  MembershipSubscriptionPlan,
  PostCategoryDetail,
} from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import { PostEditForm, PostEditFormProps } from './PostEditForm'

export * from './fragments'

export type State = {
  artistId: string
  post: ConsolePostEditQuery['post']
  plans: Maybe<Pick<MembershipSubscriptionPlan, 'planId' | 'title'>>[]
  loadingEditPost: boolean
  categories: Maybe<Pick<PostCategoryDetail, 'id' | 'name'>>[]
}

export type Action = {
  onPostEdit: PostEditFormProps['onSubmitPostEdit']
}

export const ConsolePostEditTemplate: Template<State, Action> = ({
  state,
  onPostEdit,
}) => {
  const { t } = useTranslation('consolePostEdit')
  const { routerNames, routerPages, generatePath, router } =
    useRouter<{ postId: string }>()

  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <Head title={routerNames.ConsolePostEdit} />

      <BaseLayout
        header={{
          back: true,
          defaultBackPage: generatePath(routerPages.ConsolePostDetail, {
            postId: router.query.postId ?? '#',
          }),
          title: t('title'),
        }}
      >
        {state.post && (
          <PostEditForm
            artistId={state.artistId}
            categories={state.categories}
            onSubmitPostEdit={onPostEdit}
            post={state.post}
            plans={state.plans}
            loadingEditPost={state.loadingEditPost}
          />
        )}
      </BaseLayout>
    </ArtistThemeProvider>
  )
}
